var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "vux-toast"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isShowMask && _vm.show,
      expression: "isShowMask && show"
    }],
    staticClass: "weui-mask_transparent"
  }), _c('transition', {
    attrs: {
      "name": _vm.currentTransition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.show,
      expression: "show"
    }],
    staticClass: "weui-toast",
    class: _vm.toastClass,
    style: {
      width: _vm.width
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.type !== 'text',
      expression: "type !== 'text'"
    }],
    staticClass: "weui-icon-success-no-circle weui-icon_toast"
  }), _vm.text ? _c('p', {
    staticClass: "weui-toast__content",
    style: _vm.style,
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }) : _c('p', {
    staticClass: "weui-toast__content",
    style: _vm.style
  }, [_vm._t("default")], 2)])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };